import Banner from './components/Banner';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import TrendingRanking from './components/TrendingRanking';
import LatestUpdates from './components/LatestUpdates';
import StatsStrip from './components/StatsStrip';
import { siteInfo } from '@/mocks/comics';
import SEOHead from '@/components/feature/SEOHead';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '51漫画网',
    url: 'https://51manhua.com',
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://51manhua.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51漫画网',
    url: 'https://51manhua.com',
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.contact.email,
      contactType: 'customer service',
    },
  };

  return (
    <>
      <SEOHead
        title="韩国漫画免费在线阅读-好看的韩漫大全-下拉式漫画全集-51漫画网"
        description="通过51漫画网可免费在线阅读韩漫大全，下拉式漫画全集呈现完整剧情，为用户提供连续不断的精彩韩漫阅读体验。海量韩漫免费阅读，韩国漫画全集在线观看，每日更新热门韩漫。"
        keywords="韩漫免费阅读,韩漫大全,下拉式全集,51漫画网,韩国漫画,免费漫画,在线漫画"
        canonicalUrl="/"
        schema={{ ...websiteSchema, ...organizationSchema }}
      />
      <main>
        <Banner />
        <StatsStrip />
        <CategoryNav />
        <FeaturedComics />
        <TrendingRanking />
        <LatestUpdates />
      </main>
    </>
  );
}